import axios, { AxiosResponse } from 'axios';
import { auth } from 'utils/firebase';
import envConfig from 'config/env.config';

const axiosClient = axios.create({
  baseURL: envConfig.apiUrl,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Add a request interceptor
axiosClient.interceptors.request.use(
  async function (config) {
    const user = auth.currentUser;

    if (user) {
      const token = await user.getIdToken();
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },

  function (error) {
    return Promise.reject(error);
  },
);

// Add a response interceptor
axiosClient.interceptors.response.use(
  (response: AxiosResponse) => response.data ?? response,
  (error) => Promise.reject(error),
);

export default axiosClient;
